export default __webpack_public_path__ + "static/media/text-images.png?.752458d4";